export default (container, done) => {
    smoother.paused(true)
    const loader = document.querySelector('[data-transition-primary]')
    const bar = loader.querySelector('[data-loading-bar]')

    const tl = gsap.timeline({
        defaults: { ease: 'circ.inOut' },
        onComplete: () => {
            done()
        },
    })

    tl.to(loader, { autoAlpha: 1, duration: 0.3 }).fromTo(
        bar,
        { xPercent: -101 },
        { duration: 0.6, xPercent: 0, ease: 'circ.inOut' },
    )
}
